<template>
	<div class="container__planejamento">
		<div class="container__planejamento__topo">
			<p class="container__planejamento__topo__title">
				{{ $t('planOrderServiceCronogram') }}
			</p>
			<p class="container__planajemanto__topo__etapa">{{ $t('step') }} 3 {{ $t('of') }} 3</p>
			<p class="container__planejamento__topo__periodo">
				{{ $t('creatingServiceOrderToPeriod') }}: <i class="fas fa-calendar" />
				<span> {{ intervaloDeDatasDoCronograma }}</span>
			</p>
		</div>

		<div class="container__planejamento__corpo">
			<div class="container__planejamento__corpo__interacoes__calendario__botoes">
				<div
					class="container__planejamento__corpo__interacoes__calendario__botoes__excluir__pesquisa"
				>
					<Button
						icon="fas fa-trash"
						color="trv-error"
						width-auto
						outlined
						:disabled="desabilitarBotaoDeExclusao"
						@click="excluirPlanejamento"
					/>
					<Button
						style="flex-basis: 10rem"
						color="trv-error"
						width-auto
						outlined
						:label="$t('deleteAll')"
						@click="excluirTodosOsPlanejamentos"
					/>
					<InputSearch v-model="filtroGantt" />
				</div>
				<div
					class="container__planejamento__corpo__interacoes__calendario__botoes__interacao__calendario"
				>
					<div
						class="container__planejamento__corpo__interacoes__calendario__botoes__interacao__calendario__item"
					>
						<ButtonDropdown
							v-if="!transporGantt"
							v-model="ordenacaoGanttEstratos"
							icon="fas fa-sort-amount-down-alt"
							semantic-class="mini"
							:options="[
								{ label: $t('stratum'), value: 'estrato' },
								{ label: $t('team'), value: 'equipe' },
								{ label: $t('serviceTypeOrder'), value: 'tipoOS' },
								{ label: $t('startsDate'), value: 'start' },
								{ label: $t('deadlines'), value: 'end' },
							]"
						/>
						<ButtonDropdown
							v-else
							v-model="ordenacaoGanttEquipes"
							icon="fas fa-sort-amount-down-alt"
							semantic-class="mini"
							:options="[
								{ label: $t('team'), value: 'executorId' },
								{ label: $t('plot'), value: 'quantidadeDeParcelas' },
							]"
						/>
						<Button
							lefticon="fas fa-magic"
							:label="$t('optimizationRulesTitle')"
							color="trv-primary"
							width-auto
							outlined
							@click="abrirRegrasDeOtimizacao"
						/>
						<Button
							:label="$t('export')"
							color="trv-primary"
							width-auto
							outlined
							@click="downloadCSV"
						/>
					</div>
					<div
						class="container__planejamento__corpo__interacoes__calendario__botoes__interacao__calendario__item"
					>
						<DatePickerRange
							v-model="rangeDeVisualizacao"
							label=""
							style="margin-right: 0.5rem"
						/>
						<Button
							lefticon="fas fa-random"
							:label="labelBotaoTranspor"
							color="trv-primary"
							width-auto
							outlined
							@click="transporGrafico"
						/>
						<Button
							icon="fas fa-search-minus"
							width-auto
							outlined
							@click="() => zoomCalendario++"
						/>
						<Button
							icon="fas fa-search-plus"
							width-auto
							outlined
							@click="() => zoomCalendario--"
						/>
						<Button
							icon="fas fa-expand-arrows-alt"
							width-auto
							outlined
							@click="expandirTela"
						/>
					</div>
				</div>
			</div>
			<div :class="['container__planejamento__corpo__calendario', { estaExpandido }]">
				<Chart
					v-if="planejamentos.length > 0"
					ref="ref__chart"
					:options="chartOptions"
				/>
			</div>
		</div>

		<div class="container__planejamento__rodape">
			<div class="container__planejamento__rodape__botoes">
				<Button
					:label="$t('back')"
					outlined
					:disabled="salvandoParaContinuarMaisTarde || salvandoOrdensDeServico"
					@click="voltarParaListagemDeCronogramas"
				/>
				<Button
					:label="$t('conclude')"
					:disabled="salvandoParaContinuarMaisTarde"
					:loading="salvandoOrdensDeServico"
					@click="salvarOrdensDeServico"
				/>
			</div>
			<div class="container__planejamento__rodape__continuar__mais__tarde">
				<div style="display: flex">
					<Loading v-show="salvandoParaContinuarMaisTarde" />
					<p @click="salvarConfiguracoesDePlanejamento">
						{{ $t('saveAndContinueLater') }}
					</p>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { Chart } from 'highcharts-vue'
import Button from '../../../../../components/Button/Button'
import ButtonDropdown from '../../../../../components/ButtonDropdown/ButtonDropdown'
import DatePickerRange from '../../../../../components/DatePickerRange/DatePickerRange'
import InputSearch from '../../../../../components/InputSearch/InputSearch'
import Loading from '../../../../../components/Loading/Loading'
import { exportarCsv } from '../../../../../utils/csvHellpers'

import { buscarFeriadosPorAno } from '../../../../../services/requests/ApiExternalRequests'
import { getAllExecutores, getAllFazendas } from '../../../../../services/requests/ExecutorRequests'

export default {
	components: {
		Button,
		Chart,
		DatePickerRange,
		ButtonDropdown,
		InputSearch,
		Loading,
	},
	props: {
		extenderPlanejamento: {
			type: Function,
			required: true,
		},
		abrirRegrasDeOtimizacao: {
			type: Function,
			rquired: true,
		},
		voltarParaListagemDeCronogramas: {
			type: Function,
			required: true,
		},
		estratoEmVisualizacao: Object,
		estaExpandido: Boolean,
		estratosPresentesNoAgrupamento: Array,
		salvandoParaContinuarMaisTarde: Boolean,
		salvandoOrdensDeServico: Boolean,
	},
	data() {
		return {
			dataDeInicio: new Date(),
			dataDeFinalizacao: new Date(new Date().setDate(new Date().getDate() + 365)),
			planejamentos: [],
			fazendas: [],
			feriadosNoAno: [],
			ordenacaoGanttEstratos: 'estrato',
			ordenacaoGanttEquipes: 'executorId',
			filtroGantt: '',
			zoomCalendario: 0,
			executores: [],
			rangeDeVisualizacao: undefined,
			forceRefreshChart: 0,
			transporGantt: false,
		}
	},
	computed: {
		desabilitarBotaoDeExclusao() {
			if (this.estratoEmVisualizacao !== undefined)
				return !this.estratoEmVisualizacao.podeExcluirPlanejamento
			return true
		},
		intervaloDeDatasDoCronograma() {
			return `${this.dataDeInicioFormatada} - ${this.dataDeFinalizacaoFormatada}`
		},
		dateDataDeInicio() {
			return new Date(this.dataDeInicio)
		},
		dataDeInicioFormatada() {
			const dia = this.dateDataDeInicio.getDate().toString().padStart(2, '0')
			const mes = (this.dateDataDeInicio.getMonth() + 1).toString().padStart(2, '0')
			const ano = this.dateDataDeInicio.getFullYear()

			return `${dia}/${mes}/${ano}`
		},
		dateDataDeFinalizacao() {
			return new Date(this.dataDeFinalizacao)
		},
		dataDeFinalizacaoFormatada() {
			const dia = this.dateDataDeFinalizacao.getDate().toString().padStart(2, '0')
			const mes = (this.dateDataDeFinalizacao.getMonth() + 1).toString().padStart(2, '0')
			const ano = this.dateDataDeFinalizacao.getFullYear()

			return `${dia}/${mes}/${ano}`
		},
		labelBotaoTranspor() {
			return this.transporGantt ? this.$t('stratums') : this.$t('teams')
		},
		dadosParaSeries() {
			this.forceRefreshChart

			const planejamentos = this.planejamentos
				.map((planejamento) => {
					let descricaoOS = ''

					switch (planejamento.tipoDeOrdemDeServicoPlanejada) {
						case '001':
							descricaoOS = this.$t('instalationInventory')
							break
						case '002':
							descricaoOS = this.$t('continueInventory')
							break
						case '003':
							descricaoOS = this.$t('preCut')
							break
						default:
							descricaoOS = planejamento.tipoDeOrdemDeServicoPlanejada
					}

					const executor = this.executores.find(
						(executor) => executor.id === planejamento.executorId,
					)

					const corEstrato =
						this.estratoEmVisualizacao.estratoFlorestalId === planejamento.estratoFlorestalId
							? '#95bb49'
							: this.estratosPresentesNoAgrupamento.includes(planejamento.estratoFlorestalId)
								? '#f6fa00'
								: '#000000'

					return {
						name: `${planejamento.estrato}`,
						corEstrato: corEstrato,
						estrato: planejamento.estrato,
						start: planejamento.inicioOs,
						end: planejamento.prazoOs,
						color: '#01395e',
						tipoOS: descricaoOS,
						quantidadeDeParcelas: planejamento.quantidadeDeParcelas,
						planejamentoId: planejamento.planejamentoId,
						equipe: executor !== undefined ? executor.extr_nm_nome : this.$t('noTeam'),
					}
				})
				.filter((planejamento) => {
					const dataInicial = new Date(planejamento.start)
					const dataFinal = new Date(planejamento.end)

					const dataInicialFormatada = `${dataInicial.getUTCDate().toString().padStart(2, '0')}/${(dataInicial.getUTCMonth() + 1).toString().padStart(2, '0')}/${dataInicial.getUTCFullYear()}`
					const dataFinalFormatada = `${dataFinal.getUTCDate().toString().padStart(2, '0')}/${(dataFinal.getUTCMonth() + 1).toString().padStart(2, '0')}/${dataFinal.getUTCFullYear()}`

					const termo = `${planejamento.equipe} - ${planejamento.tipoOS} - ${planejamento.name} - ${dataInicialFormatada} / ${dataFinalFormatada}`
					return termo.includes(this.filtroGantt)
				})
				.sort((planejamento1, planejamento2) => {
					const planejamento1CorPreta = planejamento1.corEstrato === '#000000'
					const planejamento2CorPreta = planejamento2.corEstrato === '#000000'

					if (!planejamento1CorPreta && planejamento2CorPreta) {
						return 1
					} else if (planejamento1CorPreta && !planejamento2CorPreta) {
						return -1
					} else {
						const eUmaComparacaoDeStrings =
							typeof (planejamento1[this.ordenacaoGanttEstratos] === 'string') &&
							typeof planejamento2[this.ordenacaoGanttEstratos] === 'string'
						if (eUmaComparacaoDeStrings) {
							const asStringsSaoIguais =
								planejamento2[this.ordenacaoGanttEstratos].localeCompare(
									planejamento1[this.ordenacaoGanttEstratos],
								) === 0
							if (asStringsSaoIguais) {
								const diferencaEntreAsDatasDeInicio = planejamento2.start - planejamento1.start
								return diferencaEntreAsDatasDeInicio
							}
							return planejamento2[this.ordenacaoGanttEstratos].localeCompare(
								planejamento1[this.ordenacaoGanttEstratos],
							)
						}
						return (
							planejamento2[this.ordenacaoGanttEstratos] -
							planejamento1[this.ordenacaoGanttEstratos]
						)
					}
				})

			let indicePlanejamentos = planejamentos.length - 1
			let posicaoNoGantt = 0

			while (indicePlanejamentos >= 0) {
				planejamentos[indicePlanejamentos].y = posicaoNoGantt
				indicePlanejamentos--
				posicaoNoGantt++
			}

			return planejamentos
		},
		dadosParaSeriesExecutores() {
			this.forceRefreshChart

			const planejamentosAgrupadosPorExecutor = Object.groupBy(
				this.planejamentos,
				(planejamento) => planejamento.executorId,
			)

			const planejamentosOrdenados = Object.values(planejamentosAgrupadosPorExecutor).sort(
				(planejamentosDoExecutor1, planejamentosDoExecutor2) => {
					if (this.ordenacaoGanttEquipes === 'executorId') {
						const executorId1 = planejamentosDoExecutor1[0][this.ordenacaoGanttEquipes]
						const executor1 = this.executores.find((executor) => executor.id === executorId1)

						const executorId2 = planejamentosDoExecutor2[0][this.ordenacaoGanttEquipes]
						const executor2 = this.executores.find((executor) => executor.id === executorId2)

						const nomeExecutor1 =
							executor1 !== undefined ? executor1.extr_nm_nome : this.$t('noTeam')
						const nomeExecutor2 =
							executor2 !== undefined ? executor2.extr_nm_nome : this.$t('noTeam')

						return nomeExecutor1.localeCompare(nomeExecutor2)
					}

					const planejamento1 = planejamentosDoExecutor1.reduce(
						(acumulador, planejamento) => planejamento[this.ordenacaoGanttEquipes] + acumulador,
						0,
					)
					const planejamento2 = planejamentosDoExecutor2.reduce(
						(acumulador, planejamento) => planejamento[this.ordenacaoGanttEquipes] + acumulador,
						0,
					)

					return planejamento1 - planejamento2
				},
			)

			const series = []

			let linhaAtual = 0

			planejamentosOrdenados.forEach((planejamentos) => {
				const quantidadeDeParcelas = planejamentos.reduce(
					(acumulador, planejamento) => planejamento.quantidadeDeParcelas + acumulador,
					0,
				)

				const quantidadeDeDiasAlocados = planejamentos
					.map((planejamento) => {
						const diferencaEmMilisegundos = planejamento.prazoOs - planejamento.inicioOs
						const umDiaEmMilisegundos = 86400000
						return diferencaEmMilisegundos / umDiaEmMilisegundos
					})
					.reduce((acumulador, dias) => acumulador + dias, 0)

				const data = planejamentos.map((planejamento) => {
					let corNoGrafico = 'rgb(1, 57, 94)'

					const estratoPresenteNoGrupo = this.estratosPresentesNoAgrupamento.includes(
						planejamento.estratoFlorestalId,
					)
					if (estratoPresenteNoGrupo) corNoGrafico = 'rgb(246, 250, 0)'

					const planejamentoSelecionado =
						planejamento.planejamentoId === this.estratoEmVisualizacao.planejamentoId
					if (planejamentoSelecionado) corNoGrafico = 'rgb(149, 187, 73)'

					const executorId = planejamento.executorId
					const executor = this.executores.find((executor) => executor.id === executorId)

					return {
						start: planejamento.inicioOs,
						end: planejamento.prazoOs,
						estrato: planejamento.estrato,
						diasAlocados: `${quantidadeDeDiasAlocados} ${this.$t('days')}`,
						y: linhaAtual,
						equipe: executor !== undefined ? executor.extr_nm_nome : this.$t('noTeam'),
						parcelasAlocadas: `${quantidadeDeParcelas} ${this.$t('plots2')}`,
						planejamentoId: planejamento.planejamentoId,
						color: corNoGrafico,
					}
				})

				series.push(...data)
				linhaAtual++
			})

			return series.filter((data) => {
				const termo = `${data.equipe} ${data.parcelasAlocadas} ${data.estrato}`
				return termo.includes(this.filtroGantt)
			})
		},
		plotBandsParaOGantt() {
			const finaisDeSemana = this.finaisDeSemanaPlotBands
			const feriados = this.feriadosPlotBands

			return finaisDeSemana.concat(feriados)
		},
		finaisDeSemanaPlotBands() {
			let dataMinimaHighcharts = new Date(this.diaMinimoHighcharts)
			const dataMaximaHighcharts = new Date(this.diaMaximoHighcharts)

			const finaisDeSemana = []
			const sabado = 6

			while (dataMinimaHighcharts.getTime() <= dataMaximaHighcharts.getTime()) {
				if (dataMinimaHighcharts.getDay() == sabado) {
					const dataReferencia = new Date(dataMinimaHighcharts.getTime())

					finaisDeSemana.push({
						color: {
							pattern: {
								path: 'M 0 10 L 10 0 M -1 1 L 1 -1 M 9 11 L 11 9',
								width: 10,
								height: 10,
								color: 'rgba(128, 128, 128, 0.2)',
							},
						},
						from: new Date(dataReferencia.getTime()),
						to: new Date(dataReferencia.setDate(dataReferencia.getDate() + 2)),
					})
				}
				dataMinimaHighcharts = new Date(
					dataMinimaHighcharts.setDate(dataMinimaHighcharts.getDate() + 1),
				)
			}
			return finaisDeSemana
		},
		feriadosPlotBands() {
			const vm = this

			return this.feriadosNoAno.map((feriado) => {
				return {
					color: {
						pattern: {
							path: 'M 0 10 L 10 0 M -1 1 L 1 -1 M 9 11 L 11 9',
							width: 10,
							height: 10,
							color: 'rgba(256, 0, 0, 0.2)',
						},
					},
					from: new Date(feriado.date),
					to: new Date(new Date(feriado.date).setDate(new Date(feriado.date).getDate() + 1)), // Incrementa 1 dia
					events: {
						mousemove(e) {
							let x = e.x - 50
							let y = 30

							const chart = vm.$refs.ref__chart
							const tooltipEstaCriado =
								chart.chart.annotationTooltip &&
								Object.keys(chart.chart.annotationTooltip).length > 0

							chart.chart.annotationTooltip && tooltipEstaCriado
								? chart.chart.annotationTooltip.destroy()
								: null

							const [ano, mes, dia] = feriado.date.split('-')

							const tooltip = `
                                <p style="margin:0; font-size:.875rem;font-weigth:700;">${feriado.name}</p><br>
                                <p style="margin:0; font-size:.7rem">${dia}/${mes}/${ano}</p>
                            `

							chart.chart.annotationTooltip = chart.chart.renderer
								.label(tooltip, x, y)
								.css({
									color: '#FFFFFF',
								})
								.attr({
									fill: 'rgb(149, 187, 73)',
									padding: 5,
									zIndex: 10,
									r: 5,
								})
								.add()
						},
						mouseout() {
							const chart = vm.$refs.ref__chart
							const tooltipEstaCriado =
								chart.chart.annotationTooltip &&
								Object.keys(chart.chart.annotationTooltip).length > 0

							if (chart.chart.annotationTooltip && tooltipEstaCriado)
								chart.chart.annotationTooltip.destroy()
						},
					},
				}
			})
		},
		anosDistintosEntreDuasDatas() {
			let anoIncremental = this.dateDataDeInicio.getFullYear()
			const anoFinal = this.dateDataDeFinalizacao.getFullYear()

			const anosDistintos = []

			while (!anosDistintos.includes(anoFinal)) {
				anosDistintos.push(anoIncremental)
				anoIncremental++
			}

			return anosDistintos
		},
		diaMinimoHighcharts() {
			const zoomDeQuinzeDias = 1296000000

			if (this.rangeDeVisualizacao)
				return this.rangeDeVisualizacao.start.getTime() - this.zoomCalendario * zoomDeQuinzeDias

			const timestampDeInicioDeOS = this.planejamentos.map((planejamento) => planejamento.inicioOs)
			const timestampDePrazosDeOS = this.planejamentos.map((planejamento) => planejamento.prazoOs)

			const todosOsTimestamps = timestampDeInicioDeOS.concat(timestampDePrazosDeOS)
			const menorTimestamp = Math.min(...todosOsTimestamps)

			return menorTimestamp - this.zoomCalendario * zoomDeQuinzeDias
		},
		diaMaximoHighcharts() {
			const zoomDeQuinzeDias = 1296000000

			if (this.rangeDeVisualizacao)
				return this.rangeDeVisualizacao.end.getTime() + this.zoomCalendario * zoomDeQuinzeDias

			const timestampDeInicioDeOS = this.planejamentos.map((planejamento) => planejamento.inicioOs)
			const timestampDePrazosDeOS = this.planejamentos.map((planejamento) => planejamento.prazoOs)

			const todosOsTimestamps = timestampDeInicioDeOS.concat(timestampDePrazosDeOS)
			const maiorTimestamp = Math.max(...todosOsTimestamps)

			return maiorTimestamp + this.zoomCalendario * zoomDeQuinzeDias
		},

		chartOptions() {
			if (this.transporGantt) {
				return this.ganttExecutores
			} else {
				return this.ganttPlanejamento
			}
		},
		ganttPlanejamento() {
			const vm = this

			return {
				chart: {
					type: 'gantt',
				},

				exporting: {
					enabled: false,
				},

				title: {
					text: '',
				},

				plotOptions: {
					series: {
						dragDrop: {
							draggableX: true,
							dragPrecisionX: 86400000, // Precisao do drag em (ms)
						},
						dataLabels: {
							enabled: true,
							format: '{point.equipe}',
							style: {
								cursor: 'pointer',
								pointerEvents: 'none',
							},
						},
					},
				},

				xAxis: {
					currentDateIndicator: {
						color: '#93bb49',
						dashStyle: 'Solid',
						width: 1,
						label: {
							format: '',
						},
					},
					plotBands: this.plotBandsParaOGantt,
					opposite: true,
					type: 'datetime',
					dateTimeLabelFormats: {
						day: '<span style="font-size:.8rem; color:#01395e"><b>%e</b><br> <span style="font-size:.7rem;">%b</span></span>',
						week: '<span style="font-size:.8rem; color:#01395e"><b>%e</b><br> <span style="font-size:.7rem;">%b</span></span>',
						month:
							'<span style="font-size:.8rem; color:#01395e"><b>%b</b><br> <span style="font-size:.7rem;">%y</span></span>',
						year: '<span style="font-size:.8rem; color:#01395e"><b>%Y</b>',
					},
					min: this.diaMinimoHighcharts,
					max: this.diaMaximoHighcharts,
				},
				legend: {
					enabled: false,
				},

				yAxis: {
					type: 'category',
					gridLineWidth: 1,
					gridLineColor: '#ebebeb',
					staticScale: 40,
					min: 0,
					max: 7,
					reversed: true,
					scrollbar: {
						enabled: true,
						position: 'top',
						barBackgroundColor: '#c2c2c2',
						barBorderRadius: 7,
						barBorderWidth: 0,
						buttonBackgroundColor: '#c2c2c2',
						buttonBorderWidth: 0,
						buttonArrowColor: 'white',
						buttonBorderRadius: 7,
						rifleColor: 'white',
						trackBackgroundColor: '#f2f2f2',
						trackBorderWidth: 1,
						trackBorderColor: 'silver',
						liveRedraw: false,
					},
					grid: {
						enabled: true,
						borderColor: '#ebebeb',
						borderWidth: 1,
						columns: [
							{
								title: {
									text: this.$t('stratum'),
									style: {
										color: '#01395e',
										fontSize: '.7rem',
										fontWeight: 700,
										fontFamily: 'Open Sans',
									},
								},
								labels: {
									formatter: function (point) {
										if (point.point) {
											if (point.point.corEstrato !== '#000000') {
												const corDaTag = point.point.corEstrato
												const corDaFonte = corDaTag === '#95bb49' ? '#ffffff' : '#000000'

												return `
                                                <div style="background-color:${corDaTag}; padding:2px 15px; border-radius:50px">
                                                    <p style="color: ${corDaFonte}; font-weight: 700; margin:0;"> ${point.point.estrato}</p>
                                                </div>
                                            `
											}
											return `<p>${point.point.estrato}</p>`
										}
									},
									useHTML: true,
								},
							},
							{
								title: {
									text: this.$t('osType'),
									style: {
										color: '#01395e',
										fontSize: '.7rem',
										fontWeight: 700,
										fontFamily: 'Open Sans',
									},
								},
								labels: {
									format: '{point.tipoOS}',
									style: {
										color: '#0C0B0B',
										fontSize: '.8rem',
										fontWeight: 400,
										fontFamily: 'Open Sans',
									},
								},
							},
							{
								title: {
									text: this.$t('startsDate'),
									style: {
										color: '#01395e',
										fontSize: '.7rem',
										fontWeight: 700,
										fontFamily: 'Open Sans',
									},
								},
								labels: {
									format: '{point.start:%d/%m/%Y}',
									style: {
										color: '#0C0B0B',
										fontSize: '.8rem',
										fontWeight: 400,
										fontFamily: 'Open Sans',
									},
								},
							},
							{
								title: {
									text: this.$t('deadlines'),
									style: {
										color: '#01395e',
										fontSize: '.7rem',
										fontWeight: 700,
										fontFamily: 'Open Sans',
									},
								},
								labels: {
									format: '{point.end:%d/%m/%Y}',
									style: {
										color: '#0C0B0B',
										fontSize: '.8rem',
										fontWeight: 400,
										fontFamily: 'Open Sans',
									},
								},
							},
							{
								title: {
									text: this.$t('plots'),
									style: {
										color: '#01395e',
										fontSize: '.7rem',
										fontWeight: 700,
										fontFamily: 'Open Sans',
									},
								},
								labels: {
									format: '{point.quantidadeDeParcelas}',
									style: {
										color: '#0C0B0B',
										fontSize: '.8rem',
										fontWeight: 400,
										fontFamily: 'Open Sans',
									},
								},
							},
						],
					},
				},

				// PARA HABILITAR BARRA DE NAVEGACAO INFERIOR
				// navigator: {
				//     enabled: true,
				//     liveRedraw: false,
				//     series: {
				//         type: 'gantt',
				//         pointPlacement: 0.5,
				//         pointPadding: 0.25,
				//         accessibility: {
				//             enabled: false
				//         }
				//     },
				//     yAxis: {
				//         min: 0,
				//         max: 3,
				//         reversed: true,
				//         categories: []
				//     }
				// },

				tooltip: {
					formatter: function () {
						return false
					},
				},

				series: [
					{
						name: 'Project 1',
						data: this.dadosParaSeries,
						allowPointSelect: true,
						events: {
							click: function (event) {
								vm.$nextTick(() => {
									vm.$emit('selecionouPlanejamento', event.point.planejamentoId)
								})
							},
						},
						point: {
							events: {
								drop: function (event) {
									vm.$emit(
										'selecionouNovoRangeDeDataParaOS',
										event.target.planejamentoId,
										event.newPoint,
									)
								},
							},
						},
						states: {
							select: {
								color: 'rgb(1, 57, 94)',
								borderColor: 'rgb(1, 57, 94)',
								borderWidth: 0,
							},
						},
					},
				],
			}
		},
		ganttExecutores() {
			const vm = this

			return {
				plotOptions: {
					series: {
						dataLabels: {
							format: '{point.estrato}',
						},
					},
				},

				xAxis: {
					plotBands: this.plotBandsParaOGantt,
					min: this.diaMinimoHighcharts,
					max: this.diaMaximoHighcharts,
				},

				yAxis: {
					grid: {
						columns: [
							{
								title: {
									text: this.$t('team'),
									style: {
										color: '#01395e',
										fontSize: '.7rem',
										fontWeight: 700,
										fontFamily: 'Open Sans',
									},
								},
								labels: {
									format: '{point.equipe}',
									style: {
										color: '#0C0B0B',
										fontSize: '.8rem',
										fontWeight: 400,
										fontFamily: 'Open Sans',
									},
								},
							},
							{
								title: {
									text: this.$t('plots'),
									style: {
										color: '#01395e',
										fontSize: '.7rem',
										fontWeight: 700,
										fontFamily: 'Open Sans',
									},
								},
								labels: {
									format: '{point.parcelasAlocadas}',
									style: {
										color: '#0C0B0B',
										fontSize: '.8rem',
										fontWeight: 400,
										fontFamily: 'Open Sans',
									},
								},
							},
							{
								title: {
									text: this.$t('days2'),
									style: {
										color: '#01395e',
										fontSize: '.7rem',
										fontWeight: 700,
										fontFamily: 'Open Sans',
									},
								},
								labels: {
									format: '{point.diasAlocados}',
									style: {
										color: '#0C0B0B',
										fontSize: '.8rem',
										fontWeight: 400,
										fontFamily: 'Open Sans',
									},
								},
							},
						],
					},
				},

				series: [
					{
						name: 'Project 1',
						data: this.dadosParaSeriesExecutores,
						allowPointSelect: true,
						events: {
							click: function (event) {
								vm.$nextTick(() => {
									vm.$emit('selecionouPlanejamento', event.point.planejamentoId)
								})
							},
						},
						point: {
							events: {
								drop: function (event) {
									vm.$emit(
										'selecionouNovoRangeDeDataParaOS',
										event.target.planejamentoId,
										event.newPoint,
									)
								},
							},
						},
						states: {
							select: {
								color: undefined,
								borderColor: undefined,
								borderWidth: 0,
							},
						},
					},
				],
			}
		},
	},
	watch: {
		rangeDeVisualizacao() {
			this.zoomCalendario = 0
		},
		dadosParaSeries() {
			const chart = this.$refs.ref__chart
			if (chart) {
				chart.chart.yAxis[0].setExtremes(0, 7)
			}
		},
	},
	created() {
		this.anosDistintosEntreDuasDatas.forEach((anoAtual) => {
			buscarFeriadosPorAno(anoAtual).then((response) => {
				this.feriadosNoAno.push(...response.data)
			})
		})
		getAllExecutores().then((response) => {
			this.executores = response.data.result
		})

		getAllFazendas().then((response) => {
			this.fazendas = response.data
		})
	},
	methods: {
		expandirTela() {
			this.extenderPlanejamento()
			if (this.planejamentos.length > 0) {
				this.$nextTick(() => {
					this.$refs.ref__chart.chart.reflow()
				})
			}
		},
		excluirPlanejamento() {
			this.$emit('excluiuPlanejamento', this.estratoEmVisualizacao.planejamentoId)
		},
		salvarConfiguracoesDePlanejamento() {
			this.$emit('clicouEmSalvarParaContinuarMaisTarde')
		},
		salvarOrdensDeServico() {
			this.$emit('clicouParaCriarOrdensDeServico')
		},
		forcarAtualizacaoDoGrafico() {
			this.forceRefreshChart++
		},
		transporGrafico() {
			this.transporGantt = !this.transporGantt
			this.filtroGantt = ''
			this.forcarAtualizacaoDoGrafico()
		},
		excluirTodosOsPlanejamentos() {
			this.$emit('clicouEmExcluirTodosOsPlanejamentos')
		},

		downloadCSV() {
			let cabecalhoDoCsv = [
				'Fazenda',
				'Estrato',
				'Tipo OS',
				'Prazo Inicio',
				'Prazo Final',
				'Parcelas',
				'Executor',
			]
			const items = this.planejamentos

			const linhas = items.map((item) => {
				let tipoDeOrdemDeServicoPlanejada
				switch (item.tipoDeOrdemDeServicoPlanejada) {
					case '001':
						tipoDeOrdemDeServicoPlanejada = 'Inventário de Instalação'
						break
					case '002':
						tipoDeOrdemDeServicoPlanejada = 'Inventário Contínuo'
						break
					case '003':
						tipoDeOrdemDeServicoPlanejada = 'Inventário Pré-Corte'
						break
					default:
						tipoDeOrdemDeServicoPlanejada = item.tipoDeOrdemDeServicoPlanejada
				}
				return [
					item.plantiosDoGrupo[0].properties.fazendaId
						? this.fazendas.find(
								(fazenda) => fazenda.id === item.plantiosDoGrupo[0].properties.fazendaId,
							).fzda_nm_nome
						: '',
					item.estrato,
					tipoDeOrdemDeServicoPlanejada,
					new Date(item.inicioOs).toLocaleDateString(),
					new Date(item.prazoOs).toLocaleDateString(),
					item.quantidadeDeParcelas,
					item.executorId
						? this.executores.find((executor) => executor.id === item.executorId).extr_nm_nome
						: 'Sem executor',
				]
			})

			exportarCsv('export_cronograma', cabecalhoDoCsv, linhas)
		},
	},
}
</script>

<style scoped>
p {
	margin: 0;
	cursor: default;
}

.container__planejamento {
	padding: 2rem;
	font-size: 0.875rem;
	line-height: normal;
	font-weight: 400;
	display: flex;
	flex-direction: column;
}

.container__planejamento__topo__title {
	color: rgb(var(--color-primary));
	font-size: 1.5rem;
	font-weight: 700;
}

.container__planajemanto__topo__etapa {
	color: var(--color-cinza-escuro);
	margin-bottom: 0.5rem;
}

.container__planejamento__topo__periodo {
	color: black;
}

.container__planejamento__topo__periodo > i {
	color: rgb(var(--color-default));
	padding-left: 0.5rem;
	padding-right: 0.2rem;
}

.container__planejamento__topo__periodo > span {
	color: var(--color-cinza-escuro);
}

.container__planejamento__corpo {
	height: 100%;
	margin-bottom: 0.5rem;
	display: flex;
	flex-direction: column;
}

.container__planejamento__corpo__interacoes__calendario__botoes__excluir__pesquisa {
	display: flex;
	margin-top: 0.5rem;
}

.container__planejamento__corpo__interacoes__calendario__botoes__interacao__calendario {
	display: flex;
	justify-content: space-between;
	margin-top: 0.5rem;
}

.container__planejamento__corpo__interacoes__calendario__botoes__interacao__calendario__item {
	display: flex;
}

.container__planejamento__rodape {
	margin-top: auto;
}

.container__planejamento__rodape__botoes {
	display: flex;
}

.container__planejamento__rodape__continuar__mais__tarde {
	display: flex;
	justify-content: flex-end;
	margin-top: 1rem;
}

.container__planejamento__rodape__continuar__mais__tarde p {
	color: rgb(var(--color-primary));
	text-decoration-line: underline;
	cursor: pointer;
	flex: none;
	margin-left: 0.5rem;
}

.container__planejamento__corpo__calendario {
	overflow-y: auto;
	margin-top: 1rem;
	height: 100%;
	max-height: calc(100vh - 400px);
	display: none;
}

.container__planejamento__corpo__calendario.estaExpandido {
	display: inline-block;
}

@media screen and (min-width: 992px) {
	.container__planejamento {
		height: calc(100vh - 40px);
	}

	.container__planejamento__corpo__calendario {
		max-height: calc(100vh - 350px);
		display: inline-block;
	}
}
</style>
